/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Book_LessonInputs */

const en_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a Lesson`)
};

const es_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una lección`)
};

const de_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde buchen`)
};

const zh_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约课程`)
};

const ar_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً`)
};

const fr_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon`)
};

const vi_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học`)
};

const sw_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka Nafasi ya Somo`)
};

const th_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียน`)
};

const bs_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju`)
};

const ja_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンを予約`)
};

const ko_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약`)
};

const pt_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendar aula`)
};

const it_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione`)
};

const sv_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka lektion`)
};

const nl_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les boeken`)
};

const da_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion`)
};

const nb_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill time`)
};

const fi_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa tunti`)
};

const pl_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję`)
};

const ru_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на урок`)
};

const tr_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders ayırt`)
};

const hi_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करें`)
};

const id_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan les`)
};

const ms_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah kelas`)
};

const cs_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervovat lekci`)
};

const el_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα`)
};

const he_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמנת שיעור`)
};

const af_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n les`)
};

const hu_nav_book_lesson = /** @type {(inputs: Nav_Book_LessonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óra foglalása`)
};

/**
* | output |
* | --- |
* | "Book a Lesson" |
*
* @param {Nav_Book_LessonInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_book_lesson = /** @type {((inputs?: Nav_Book_LessonInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Book_LessonInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_book_lesson(inputs)
	if (locale === "de") return de_nav_book_lesson(inputs)
	if (locale === "zh") return zh_nav_book_lesson(inputs)
	if (locale === "ar") return ar_nav_book_lesson(inputs)
	if (locale === "fr") return fr_nav_book_lesson(inputs)
	if (locale === "vi") return vi_nav_book_lesson(inputs)
	if (locale === "sw") return sw_nav_book_lesson(inputs)
	if (locale === "th") return th_nav_book_lesson(inputs)
	if (locale === "bs") return bs_nav_book_lesson(inputs)
	if (locale === "ja") return ja_nav_book_lesson(inputs)
	if (locale === "ko") return ko_nav_book_lesson(inputs)
	if (locale === "pt") return pt_nav_book_lesson(inputs)
	if (locale === "it") return it_nav_book_lesson(inputs)
	if (locale === "sv") return sv_nav_book_lesson(inputs)
	if (locale === "nl") return nl_nav_book_lesson(inputs)
	if (locale === "da") return da_nav_book_lesson(inputs)
	if (locale === "nb") return nb_nav_book_lesson(inputs)
	if (locale === "fi") return fi_nav_book_lesson(inputs)
	if (locale === "pl") return pl_nav_book_lesson(inputs)
	if (locale === "ru") return ru_nav_book_lesson(inputs)
	if (locale === "tr") return tr_nav_book_lesson(inputs)
	if (locale === "hi") return hi_nav_book_lesson(inputs)
	if (locale === "id") return id_nav_book_lesson(inputs)
	if (locale === "ms") return ms_nav_book_lesson(inputs)
	if (locale === "cs") return cs_nav_book_lesson(inputs)
	if (locale === "el") return el_nav_book_lesson(inputs)
	if (locale === "he") return he_nav_book_lesson(inputs)
	if (locale === "af") return af_nav_book_lesson(inputs)
	if (locale === "hu") return hu_nav_book_lesson(inputs)
	return en_nav_book_lesson(inputs)
});